// TDIC: EmailUtil.js file added newly
import _ from 'lodash';

const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/;

function checkEmailValidity(email) {
    return EMAIL_REGEX.test(email);
}

function isEmpty(value) {
    return _.isNil(value) || _.isEmpty(value);
}

export default {
    isEmpty,
    checkEmailValidity
};
